import http from '../common/http';
import env from '../envConfig';
import { getHeader, getHeaderIdPositiva } from '../auth/authManager';
import { responseHandler } from '../common/responseHandler';

export const quantidadeMensagensNaoLidasPorPessoa = async (idPessoa: any, isGovBr: boolean) => {
  const url = env.urlApi + `/transacional-api/v1/mensagem/pessoa/${idPessoa}/quantidade/nao-lida`;
  const headers = isGovBr ? getHeader() : getHeaderIdPositiva();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const obterMensagensPorPessoa = async (idPessoa: any, isGovBr: boolean) => {
  const url = env.urlApi + `/transacional-api/v1/mensagem/pessoa/${idPessoa}`;
  const headers = isGovBr ? getHeader() : getHeaderIdPositiva();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const detalharMensagemPessoa = async (idPessoa: any, idMensagemPessoa: string, isGovBr: boolean) => {
  const url = env.urlApi + `/transacional-api/v1/mensagem/pessoa/${idPessoa}/detalhe/${idMensagemPessoa}`;
  const headers = isGovBr ? getHeader() : getHeaderIdPositiva();
  const response = await http.put(url, null, { headers });
  return responseHandler(response);
};

export const detalharMensagemProximaPessoa = async (idPessoa: any, idMensagemPessoa: string, isGovBr: boolean) => {
  const url = env.urlApi + `/transacional-api/v1/mensagem/pessoa/${idPessoa}/detalhe/${idMensagemPessoa}/proxima`;
  const headers = isGovBr ? getHeader() : getHeaderIdPositiva();
  const response = await http.put(url, null, { headers });
  return responseHandler(response);
};

export const detalharMensagemAnteriorPessoa = async (idPessoa: any, idMensagemPessoa: string, isGovBr: boolean) => {
  const url = env.urlApi + `/transacional-api/v1/mensagem/pessoa/${idPessoa}/detalhe/${idMensagemPessoa}/anterior`;
  const headers = isGovBr ? getHeader() : getHeaderIdPositiva();
  const response = await http.put(url,  null, { headers });
  return responseHandler(response);
};

export const obterInformacoesBanner = async (idPessoa: any, isGovBr: boolean) => {
  const url = env.urlApi + `/transacional-api/v1/mensagem/pessoa/${idPessoa}/informacao-banner`;
  const headers = isGovBr ? getHeader() : getHeaderIdPositiva();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const obterInformacoesBannerRL = async (numeroFamiliar: any, isGovBr: boolean) => {
  const url = env.urlApi + `/transacional-api/v1/mensagem/representante-legal/${numeroFamiliar}/informacao-banner`;
  const headers = isGovBr ? getHeader() : getHeaderIdPositiva();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};


export const quantidadeMensagensNaoLidasPorRL = async (idRL: any, isGovBr: boolean) => {
  const url = env.urlApi + `/transacional-api/v1/mensagem/representante-legal/${idRL}/quantidade/nao-lida`;
  const headers = isGovBr ? getHeader() : getHeaderIdPositiva();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const obterMensagensPorRL = async (idRL: any, isGovBr: boolean) => {
  const url = env.urlApi + `/transacional-api/v1/mensagem/representante-legal/${idRL}`;
  const headers = isGovBr ? getHeader() : getHeaderIdPositiva();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const detalharMensagemRL = async (idRL: any, idMensagemRL: string, isGovBr: boolean) => {
  const url = env.urlApi + `/transacional-api/v1/mensagem/representante-legal/${idRL}/detalhe/${idMensagemRL}`;
  const headers = isGovBr ? getHeader() : getHeaderIdPositiva();
  const response = await http.put(url, null, { headers });
  return responseHandler(response);
};

export const detalharMensagemProximaRL = async (idRL: any, idMensagemRL: string, isGovBr: boolean) => {
  const url = env.urlApi + `/transacional-api/v1/mensagem/representante-legal/${idRL}/detalhe/${idMensagemRL}/proxima`;
  const headers = isGovBr ? getHeader() : getHeaderIdPositiva();
  const response = await http.put(url, null, { headers });
  return responseHandler(response);
};

export const detalharMensagemAnteriorRL = async (idRL: any, idMensagemRL: string, isGovBr: boolean) => {
  const url = env.urlApi + `/transacional-api/v1/mensagem/representante-legal/${idRL}/detalhe/${idMensagemRL}/anterior`;
  const headers = isGovBr ? getHeader() : getHeaderIdPositiva();
  const response = await http.put(url,  null, { headers });
  return responseHandler(response);
};
